module.exports = __webpack_public_path__ + "img/collection_food_2.c60ed4a7.png";